module.exports = __webpack_public_path__ + "img/register-v2-dark.5fa5b9f3.svg";